import React from 'react';
import { connect } from 'react-redux';

import ReactHtmlParser from 'react-html-parser';
import dompurify from 'dompurify';

import {
    Link,
} from "@material-ui/core";

import {
    t
} from "src/shared_modules/i18n";

import {
    showStaticContent,
    showExternalContent
} from "src/shared_modules/veu-visitors-core/actions/content";

const REGEXP_LINK = /(?:(%LNK%)(.+?)(%\/LNK%))|(?:(%MAIL%)(.+?)(%\/MAIL%))/gm;
const REGEXP_REMOVE_ALL_P = /<\/?p[^>]*>/g;

class LinkInText extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            // disable logging when live
            logging: (process.env.REACT_APP_DEPLOY_ENV !== 'live'),

        }
    }

    componentDidMount() {
        this.handleClickLink = this.handleClickLink.bind(this);
        this.renderLink = this.renderLink.bind(this);
    }

    handleClickLink(ev, idx, url=null) {
        ev.stopPropagation();
        ev.preventDefault();
//
//
// TODO global pages static pages switch
// via onClick props
//
        if( !url && this.props.staticUrls ) {
            url = this.props.staticUrls[idx];
        }

        if( url.startsWith("http") ) {
            this.props.showExternalContent(url);
        } else {
            this.props.showStaticContent(url);
        }
    }

    renderLink( match, idx ) {
        if( match[1] === "%LNK%" && match[3] === "%/LNK%" ) {
            // we have a link
            let inner = match[2].split("|");

            if( inner.length > 2 && inner[2].toLowerCase().trim() === "blank" ) {
                return (<Link color="secondary" key={idx} href={inner[1].trim()} rel="noreferrer" target="_blank">
                            { inner[0] }
                    </Link>);
            }

            if( inner.length > 1 ) {
                return (<Link color="secondary" href="#" key={idx} onClick={(ev)=> this.handleClickLink(ev, idx, inner[1].trim())}>
                            { inner[0] }
                    </Link>);
            }

            return (<Link color="secondary" href="#" key={idx} onClick={(ev)=> this.handleClickLink(ev, idx)}>
                        { inner[0] }
                </Link>);
        }

        if( match[4] === "%MAIL%" && match[6] === "%/MAIL%" ) {
            // we have an email
            const mailto = "mailto:"+match[5].trim();
            return (<Link color="secondary" key={idx} rel="noreferrer" target="_blank" href={mailto}>
                        { match[5] }
                </Link>);
        }
        return(null);
    }

    render() {
        let label = this.props.label;
        if( this.props.isI18n )
            label = t(this.props.label);

        var matches;
        var buffer = [];

        var idx = 0;
        var startpos = 0;

        const sanitizer = dompurify.sanitize;

        //let html = ReactHtmlParser(label);

        while( (matches = REGEXP_LINK.exec(label) ) != null ) {
            // get the text before or between different markers
            let text = label.substring(startpos, matches.index);
            text = text.replace(REGEXP_REMOVE_ALL_P, "");
            buffer.push(ReactHtmlParser(sanitizer(text)));
            //buffer.push(text);
            // store next startpos
            startpos = matches.index + matches[0].length;
            // now parse the match and render
            buffer.push( this.renderLink(matches,idx) );
            //only increment url index if the match contains a link
            if( matches[1] === "%LNK%" )
                idx++;
        }
        if( startpos < label.length ) {
            // get also the final text fragment if there is one.
            let endtext = label.substring(startpos);
            //buffer.push(endtext);
            endtext = endtext.replace(REGEXP_REMOVE_ALL_P, "");

            buffer.push(ReactHtmlParser(sanitizer(endtext)));
        }

        if( (label.indexOf("%LNK%") === -1 || label.indexOf("%/LNK%") === -1)
                && (label.indexOf("%MAIL%") === -1 || label.indexOf("%/MAIL%") === -1)
            ){
            if( this.state.logging )
                console.warn("LinkInText wrong/missing marker for " + this.props.label);
        }
        return(<React.Fragment>
                    { buffer }
            </React.Fragment>);
    }
}

/*
 * ---------------------------------------------------------------------
 * PopoverLogin Redux Container
 * ---------------------------------------------------------------------
 */
const mapStateToProps = ( state, ownProps ) => {
    return {
        lang: state.system.currentLang, // must be mapped to trigger the language change for rerendering
    };
};

const mapDispatchToProps = {
    showStaticContent,
    showExternalContent,
};


/*
 * ---------------------------------------------------------------------
 * Export the redux container
 * ---------------------------------------------------------------------
 */
export default connect(
        mapStateToProps,
        mapDispatchToProps
    )(LinkInText);
